import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSatelliteDish } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "../../theme/ThemeContext";
import { LocationMarkerPopup } from "../MainWindow";
import { useSatelightContext } from "../../provider/SatelightProvider";
import { weatherLayerGroup } from "../weather/weatherLayer";

export interface SateliteData {
  meta_device_id: string;
  name: string;
}

let isButtonClicked: boolean = false;

type SateLiteMenuProps = {
  senddValueFromSateliteMenu: (value: string) => void;
  openIncidentDropDown: (open: boolean) => void;
  openTitle: string;
  setTimeLayer: (layer: string) => void;
  weatherlayerState: string;
};

const SateLiteMenu: React.FC<SateLiteMenuProps> = ({
  senddValueFromSateliteMenu,
  openIncidentDropDown,
  openTitle,
  setTimeLayer,
  weatherlayerState,
}) => {
  const [isClicked, setIsClicked] = useState<boolean>(true);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [hoveredSatellite, setHoveredSatellite] = useState(false);
  const { theme } = useTheme();
  const { satelightListMapAdd, satelightListMap, setIsMinEyeClickSatelight,setIsSatelightClickProvider } =
    useSatelightContext();

  const toggleDropDown = () => {
    openIncidentDropDown(true);
    //senddValueFromSateliteMenu("Satellite Imagery");
    setIsClicked((prevState) => !prevState);
    if (isClicked === true) {
      senddValueFromSateliteMenu("Satellite Imagery");
      weatherLayerGroup.getLayers().clear();
      setTimeLayer("satellite not");
      setIsMinEyeClickSatelight(true);
       setIsSatelightClickProvider("satelliteNotClick"); 
    } else {
      setIsMinEyeClickSatelight(false);
      senddValueFromSateliteMenu("main");
    }
  };

  useEffect(() => {
    if (openTitle !== "main") {
      if (openTitle === "Satellite Imagery") {
        setIsClicked(false);
      } else {
        setIsClicked(true);
      }
    } else if (openTitle === "main") {
      setIsClicked(true);
    }
  }, [openTitle]);

  useEffect(() => {
    if (isClicked) {
      LocationMarkerPopup("satellite");
    } else {
      LocationMarkerPopup("satellite not");
    }
  }, [isClicked]);

  useEffect(() => {
    if (
      weatherlayerState === "windnot" ||
      weatherlayerState === "temperaturenot" ||
      weatherlayerState === "rainnot" ||
      weatherlayerState === "airPressurenot" ||
      weatherlayerState === "flood"
    ) {
      isButtonClicked = true;
      setIsClicked(true);
      if (isClicked) {
        LocationMarkerPopup("satellite");
      }
    }
  }, [weatherlayerState]);

  return (
    <>
      <div
        className="leftsidemenulist-btn-cover"
        onClick={toggleDropDown}
        onTouchStart={toggleDropDown}
      >
        <div
          onMouseEnter={() => setHoveredSatellite(true)}
          onMouseLeave={() => setHoveredSatellite(false)}
          className="leftsidemenulist-btns"
        >
          <FontAwesomeIcon
            size="1x"
            icon={faSatelliteDish}
            className="leftside-icon"
          />
        </div>
        {theme === "light" && (
          <div
            className={
              isClicked
                ? hoveredSatellite
                  ? "leftsidemenulist-btn-tooltip-hover-light"
                  : "leftsidemenulist-btn-tooltip-light"
                : "leftsidemenulist-btn-tooltip-clicked-light"
            }
            onMouseEnter={() => setHoveredSatellite(true)}
            onMouseLeave={() => setHoveredSatellite(false)}
          >
            Satellite
          </div>
        )}
        {theme !== "light" && (
          <div
            className={
              isClicked
                ? hoveredSatellite
                  ? "leftsidemenulist-btn-tooltip-hover"
                  : "leftsidemenulist-btn-tooltip"
                : "leftsidemenulist-btn-tooltip-clicked"
            }
            onMouseEnter={() => setHoveredSatellite(true)}
            onMouseLeave={() => setHoveredSatellite(false)}
          >
            Satellite
          </div>
        )}
      </div>
    </>
  );
};

export default SateLiteMenu;
